export default __webpack_public_path__ + "static/Sophie-abbae20af1e543209f1ec831bf236392.webp";